// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NAz5","col":"styles_col__1Zlus"};